import { getDesktopDeepLinkScheme } from './DesktopEnvironment';

// External destinations surfaced from the Extensions hub.
export const CEPHABLE_IOS_APP_URL = 'https://apps.apple.com/us/app/cephable/id1608826085';
export const CEPHABLE_ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.enabledplay.app&hl=en_US';
export const CEPHABLE_CONTROLLER_CREATOR_URL = 'https://controller.cephable.com';
export const CEPHABLE_DEVELOPERS_URL = 'https://developers.cephable.com';
export const CEPHABLE_PORTAL_URL = 'https://portal.cephable.com';

// the base url is handled in the api calls from the env variable API_URL
export const getBaseApiUrl = (): string => {
    const environment = process.env.ENABLED_ENVIRONMENT || 'production';
    if (environment == 'dev' || environment == 'develop') {
        return 'http://localhost:3002';
    } else if (environment == 'staging') {
        return 'https://enabled-dev.azurewebsites.net';
    } else if (environment == 'production') {
        return 'https://services.cephable.com';
    } else if (environment == 'staging-local') {
        return 'https://enabled-dev.azurewebsites.net';
    }

    return 'https://services.cephable.com';
};

export const getAuthRedirectUri = (): string => {
    if ((window as any).ADMIN_ENVIRONMENT) {
        return getAdminAuthRedirectUri();
    }
    if (!(window as any).WEB_ENVIRONMENT || (window as any).DESKTOP_ENVIRONMENT) {
        return `${getDesktopDeepLinkScheme()}://authcallback`;
    }
    if ((window as any).ENABLED_ENVIRONMENT == 'dev') {
        return 'http://localhost:3000/authcallback';
    } else if ((window as any).ENABLED_ENVIRONMENT == 'staging') {
        return 'https://enableddevportal.z13.web.core.windows.net/authcallback';
    } else if ((window as any).ENABLED_ENVIRONMENT == 'production') {
        return 'https://portal.cephable.com/authcallback';
    } else if ((window as any).ENABLED_ENVIRONMENT == 'staging-local') {
        // for parity to desktop app development
        return 'https://dev-app.cephable.com/authcallback';
    }
    return 'https://portal.cephable.com/authcallback';
};

export const getAdminAuthRedirectUri = (): string => {
    const environment = process.env.ENABLED_ENVIRONMENT || 'production';
    if (environment == 'dev' || environment == 'develop') {
        return 'http://localhost:3004/';
    } else if (environment == 'staging') {
        return 'https://enableddevportal.z13.web.core.windows.net/';
    } else if (environment == 'production') {
        return 'https://portal.cephable.com/';
    } else if (environment == 'staging-local') {
        // for parity to desktop app development
        return 'http://localhost:3004/';
    }
    return 'https://portal.cephable.com/';
};

export const getAnalyticsApiUrl = (): string => {
    const environment = process.env.ENABLED_ENVIRONMENT || 'production';
    if (environment == 'dev' || environment == 'develop') {
        return 'http://localhost:3003';
    } else if (environment == 'staging' || environment == 'staging-local') {
        return 'https://enabled-dev-analytics.azurewebsites.net';
    } else if (environment == 'production') {
        return 'https://analytics.cephable.com';
    }

    return 'https://analytics.cephable.com';
};

/**
 * The `cephable-*://app/open` deep link this build answers on — the second hop of an app callback, and
 * what {@link getAppCallbackRedirectUri}'s endpoint bounces to. The scheme is per-environment, so only
 * the build that started the flow is launched.
 */
export const getAppCallbackDeepLinkRedirectUri = (): string => {
    return `${getDesktopDeepLinkScheme()}://app/open`;
};

/**
 * The hosted `https://<api>/app/open` endpoint, used as the OAuth `redirect_uri` because many providers
 * reject a custom scheme. It bounces to {@link getAppCallbackDeepLinkRedirectUri} to re-enter the app.
 */
export const getAppCallbackRedirectUri = (): string => {
    return `${getBaseApiUrl()}/app/open`;
};
